import { useTranslation } from "react-i18next";
import PageWrapper from "../../../../../components/common/layout/PageWrapper";
import { PageContentBox, AppPageContentWrapper } from "@duosoftbg/nacid-components";
import ARUniEntryRequestAdminView from "../../../../../components/registers/admin/request/arUni/ARUniEntryRequestAdminView";

const ARUniEntryRequestAdminViewPage = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper centerTitle title={t("t.arUniEntryRequest.view")}>
      <AppPageContentWrapper>
        <PageContentBox>
          <ARUniEntryRequestAdminView />
        </PageContentBox>
      </AppPageContentWrapper>
    </PageWrapper>
  );
};
export default ARUniEntryRequestAdminViewPage;
